
import {SnackbarType} from 'common/interfaces';
import {IBrand} from 'common/interfaces/ibrand';
import {BrandActions} from 'reducers/brand-reducer';
import {
  getBrandList,
  postDeleteBrand,
  postUpdateBrand,
} from 'services/brand-service';
import {useAppDispatch} from 'setup/store';
import {useAppActions} from './app-actions';
import { useTranslation } from 'react-i18next';
export const useBrandActions = () => {
  const dispatch = useAppDispatch();
  const {showSnackBar} = useAppActions();
  const {t} = useTranslation()

  const setLoading = async (isLoading: boolean) => {
    dispatch(BrandActions.setLoading(isLoading));
  };

  const loadAllBrands = async (pageNo: number, pageSize: number) => {
    setLoading(true);
    const resp = await getBrandList();
    console.log('loadAllBrands.....', resp?.data);
    if (resp.status.success && resp.data?.items) {
      if (pageNo == 1) {
        dispatch(BrandActions.setBrands(resp.data));
      } else {
        dispatch(BrandActions.addBrands(resp.data));
      }

      setLoading(false);
      return resp.data;
    } else {
      showSnackBar(
        SnackbarType.ERROR,
        resp?.status?.msg || t('error.loadBrands') || '',
      );
    }
    setLoading(false);
  };

  
return {
    setLoading,
    loadAllBrands,
  };
};
